import React from 'react'

const Header = (props) => (
    <header id="header" style={props.timeout ? { display: 'none' } : {}}>
        <div className="logo">
            <span className="icon fa-headphones"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Dan's Place</h1>
                <p>A place to explore analogue magic<br />
                    and enjoy exquisite fascination of all things music</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('Vinyl') }}>Vinyl</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('Musical_Electronics') }}>Musical Electronics</a></li>
                {/* <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li> */}
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: React.PropTypes.func,
    timeout: React.PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js